import classNames from 'classnames';
import { type ComponentProps, type ReactNode } from 'react';

import { Avatar } from '@air/primitive-avatar';

import { getAvatarImageSrc } from '~/utils/getAvatarImageSrc';

export type LibraryInviteMemberListItemProps = Pick<ComponentProps<'div'>, 'className'> & {
  colorSeed?: string;
  avatar?: string;
  label: string;
  meta?: string;
  suffix?: ReactNode;
};

export const LibraryInviteMemberListItem = ({
  avatar,
  className,
  colorSeed,
  label,
  meta,
  suffix,
}: LibraryInviteMemberListItemProps) => {
  const initials = label
    .split(' ')
    .map((word) => word[0])
    .join('');

  return (
    <div
      className={classNames(
        'flex h-12 grow cursor-pointer items-center gap-3 rounded-4 px-2 hover:bg-pigeon-50',
        className,
      )}
    >
      <Avatar
        alt={`${label} avatar`}
        appearance="circle"
        className="shrink-0"
        colorSeed={colorSeed}
        size={32}
        src={getAvatarImageSrc(avatar, 32)}
        text={initials}
      />

      <div className="flex grow flex-col">
        <div className="font-medium text-14 text-pigeon-600">{label}</div>

        {!!meta && <div className="text-12 text-pigeon-400">{meta}</div>}
      </div>

      {!!suffix && <div className="shrink-0 text-12 text-pigeon-400 capitalize">{suffix}</div>}
    </div>
  );
};
